<script>
    import base from './base.vue';
    import * as Utils from './date-picker_utils.js';

    export default {
        name: 'single',
        extends: base,
        computed: {
            formattedDate() {
                const isValidDate = Utils.checkValidDate(this.selectedDate);
                return isValidDate ? Utils.formatDate(this.selectedDate, this.dateFormatMerged) : '';
            },
        },
        methods: {
            updateSelection(date) {
                this.selectedDate = date;
                this.hideDatePicker();
            },
        },
    };
</script>
